import {
  PredictionResultEnum,
  PriceDropMaximumRefund,
  PriceDropProtectionEnum,
} from "@b2bportal/air-shopping-api";
import { getPrediction } from "@b2bportal/core-flights";
import { useSelector } from "react-redux";

export interface UsePriceDropPredictionDetailsReturn {
  isPDPEligible: boolean;
  priceDropAmount?: PriceDropMaximumRefund;
  candidateId?: string;
}

export const usePriceDropPredictionDetails =
  (): UsePriceDropPredictionDetailsReturn => {
    const prediction = useSelector(getPrediction);
    const unavailablePrediction = {
      isPDPEligible: false,
      amount: {
        display: "",
        amount: 0,
      },
    };

    if (prediction) {
      switch (prediction.PredictionResult) {
        case PredictionResultEnum.Prediction: {
          const isPDPEligible =
            prediction &&
            prediction.priceDropProtection?.PriceDropProtection ===
              PriceDropProtectionEnum.IsEligible;

          const priceDropAmount =
            prediction && "maximumRefund" in prediction.priceDropProtection
              ? prediction?.priceDropProtection.maximumRefund
              : undefined;

          const candidateId =
            prediction && "maximumRefund" in prediction.priceDropProtection
              ? prediction?.priceDropProtection.candidateId
              : undefined;

          return {
            isPDPEligible,
            priceDropAmount,
            candidateId,
          };
        }
        case PredictionResultEnum.UnavailablePrediction:
          return unavailablePrediction;
      }
    } else {
      return unavailablePrediction;
    }
  };
